import { conferenceTypesEnum } from "../AddLessonOrMeeting/components/ConferenceType/conferenceTypesEnum";

export const actionsConfig = {
  CHANGE_DATE_TIME: {
    label: "Изменить дату и время",
    component: () => import("./components/./ChangeDateTime"),
    isAvailable: ({report, role}) => true,
  },
  CHANGE_LESSON_LINK: {
    label: "Изменить ссылку на занятие",
    component: () => import("./components/./ChangeLessonLink"),
    isAvailable: ({report, role}) => !report?.isOffline,
  },
  CHANGE_LESSON_LINK_FOR_CHILDREN: {
    label: "Изменить ссылку на занятие(Для учащихся)",
    component: () => import("./components/./ChangeLessonLinkForChildren"),
    isAvailable: ({report, settings}) => (!report?.isOffline && settings?.isSeparateLinksForStudentsAndTeachers == '1'),
  },
  CHANGE_MEETING_LEADER: {
    label: "Изменить педагога / ведущего (Замена)",
    component: () => import("./components/./ChangeMeetingLeader"),
    isAvailable: ({report, role}) => true,
  },
  CANCEL: {
    label: "Отменить",
    component: () => import("./components/./Cancel"),
    isAvailable: ({report, role}) => true,
  },
  ChANGE_AUDIENCE: {
    label: "Изменить аудиторию",
    component: () => import("./components/./ChangeAudience"),
    isAvailable: ({report, role}) => report?.isOffline,
  },
  EDIT_GROUPS: {
    label: "Редактировать группы учащихся на звонке",
    component: () => import("./components/./EditGroups"),
    isAvailable: ({report, role}) => {
      return report.conference_type === conferenceTypesEnum.group
    },
  },
  EDIT_COMMENT: {
    label: "Редактировать комментарий для сотрудников",
    component: () => import("./components/./EditComment"),
    isAvailable: ({report, role}) => {
      return report.conference_type === conferenceTypesEnum.group || report.conference_type === conferenceTypesEnum.private 
    },
  },
  EDIT_COMMENT_TO_DZ: {
    label: "Редактировать комментарий для учащихся",
    component: () => import("./components/EditCommentToDz"),
    isAvailable: ({report, role}) => {
      return report.conference_type === conferenceTypesEnum.group || report.conference_type === conferenceTypesEnum.private 
    },
  },
  EDIT_IS_OFFLINE: {
      label: "Изменить тип встречи онлайн/офлайн",
      component: () => import("./components/IsOffline"),
      isAvailable: ({report, role}) => {
        return true
    },
  },
  EDIT_IN_RECORDING: {
    label: "Изменить тип в записи/онлайн",
    component: () => import("./components/EditInRecording"),
    isAvailable: ({report, role}) => {
      return !report?.isOffline 
    },
  },
};

export const actionOptions = Object.entries(actionsConfig).map(([key, config]) => ({
  label: config.label,
  value: key,
}));